import { deserializeData } from '@apeiron/temp'
import { ApolloError, useMutation } from '@apollo/client'
import { FavoriteType } from '@src/constants/favoriteFilter'
import { removeFavoriteFilterSchema } from '@src/deserialize/yup/favoriteFilter'
import graphql from '@src/graphql/mutation/removeFavoriteFilter'
import { useCallback, useState } from 'react'

const useRemoveFavoriteFilter = (): Hook => {
  const [removeFavoriteFilter, { loading, error }] = useMutation(graphql)

  const [data, setData] = useState<Response>(false)

  const mutate = useCallback(
    async (request: Request): Promise<Response> => {
      const { type, id } = request

      const response = await removeFavoriteFilter({
        variables: {
          id,
          type
        }
      })

      const success =
        deserializeData<boolean>(response, removeFavoriteFilterSchema) || false

      setData(success)

      return success
    },
    [removeFavoriteFilter]
  )

  return {
    mutate,
    data,
    loading,
    error
  }
}

type Request = {
  type: FavoriteType
  id: string
}

type Response = boolean

type Hook = {
  mutate: (request: Request) => Promise<Response>
  data: Response
  loading: boolean
  error: ApolloError | undefined
}

export default useRemoveFavoriteFilter
